<template>
  <div class="invisible-scrollbar">
    <v-card style="display: contents">
      <div class="manage-section-page">
        <div
          class="pt-8"
          style="
            font-size: 20px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
          "
        >
          {{ $t("message.ManageSection") }}
        </div>
        <v-card-text>
          <div>
            <v-card elevation="10" class="section-filter-card">
              <v-row align="center">
                <v-col cols="12" sm="6" md="4" lg="4" style="margin-top: 25px;">
                  <v-text-field
                    :label="$t('message.Search')"
                    append-icon="mdi-database-search-outline"
                    v-model="search"
                    v-on:keyup.enter="SearchDataSectionList(search)"
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="5" lg="4" class="pt-3 section-filter-actions">
                  <v-btn
                    color="primary"
                    class="ma-2 white--text"
                    :block="$vuetify.breakpoint.xsOnly"
                    @click="getDataSectionList()"
                    >{{ $t("message.Search") }}
                    <v-icon right>mdi-magnify</v-icon>
                  </v-btn>
                  <v-btn
                    color="green"
                    class="ma-2 white--text"
                    :block="$vuetify.breakpoint.xsOnly"
                    @click="OpenSectionDetailDialog(null, 'create')"
                    >{{ $t("message.Create") }}
                    <v-icon right>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </div>
          <div>
            <v-card elevation="10" class="section-list-card">
              <v-card elevation="6" class="section-table-card">
                <div class="table-responsive">
                  <v-data-table
                    class="section-list-table"
                    :headers="headers"
                    :items="SectionList"
                    hide-default-footer
                    :items-per-page="itemsPerPage"
                    :page.sync="page"
                    :mobile-breakpoint="0"
                    single-line
                    hide-details
                  >
                    <template v-slot:item="{ item, index }">
                      <tr>
                        <td class="header-table-css">
                          {{ no_run + (index + 1) }}
                        </td>
                        <td class="header-table-css">{{ item.username }}</td>
                        <td class="header-table-css">{{ item.firstname }}</td>
                        <td class="header-table-css">
                          {{ item.lastname }}
                        </td>
                        <td class="text-center">
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            small
                            color="orange"
                            @click="
                              OpenSectionDetailDialog(item.userID, 'edit')
                            "
                          >
                            <v-icon dark>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            small
                            color="red"
                            @click="InActiveSectionBySectionID(item.userID)"
                          >
                            <v-icon dark>mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
              </v-card>

              <v-row class="mt-5 section-pagination-row" align="center">
                <v-col cols="12" md="8" lg="9" class="section-pagination-col">
                  <v-pagination
                    v-model="page"
                    :total-visible="paginationTotalVisible"
                    :length="pageCount"
                    @input="ChangePage(page)"
                  ></v-pagination>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="section-page-size-col">
                  <v-autocomplete
                    class="section-page-size"
                    dense
                    solo
                    v-model="itemsPerPage"
                    @input="ChangePerPage(itemsPerPage)"
                    :items="items"
                    label="10/page"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog
      v-model="SectionDetailDialog"
      persistent
      max-width="800px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card class="rounded-xl elevation-4 section-dialog-card">
        <v-card-title
          class="d-flex align-center justify-space-between py-4 bg-primary text-white rounded-t-xl"
        >
          <span class="text-h6 font-weight-bold">{{
            $t("message.ManageSection")
          }}</span>
          <v-btn icon @click="ClearDataSection()" class="text-white">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-6 section-dialog-content">
          <v-row dense>
            <v-col cols="12" md="4">
              <v-autocomplete
                :items="UsersList"
                item-text="name"
                v-model="UserID"
                item-value="userID"
                :label="$t('message.Username')"
                @change="FillDataNameFromUserID(UserID)"
                outlined
                dense
                :disabled="EditStatus"
                clearable
                prepend-inner-icon="mdi-account"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                :label="$t('message.FirstName')"
                v-model="FirstName"
                outlined
                disabled
                dense
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                :label="$t('message.LastName')"
                v-model="LastName"
                outlined
                disabled
                dense
              />
            </v-col>
          </v-row>
          <v-divider class="my-4"></v-divider>
          <div class="text-subtitle-1 font-weight-bold text-primary mb-2">
            {{ $t("message.Approver") }}
          </div>
          <v-row dense>
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                ref="inputApprove"
                :items="UserApproveList"
                item-text="name"
                v-model="SearchApprover"
                item-value="userID"
                :label="$t('message.Approver')"
                outlined
                dense
                clearable
                prepend-inner-icon="mdi-account"
              >
                <template v-slot:item="data">
                  <template>
                    <v-list-item-content>
                      <v-row>
                        <v-col @click="AddDataDropdownApprove(data.item)">
                          <v-list-item-title
                            v-html="data.item.name"
                          ></v-list-item-title>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12" md="12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headersDropdown"
                  :items="SelectUsersInApproveList"
                  :items-per-page="5"
                  class="elevation-1 section-approve-table"
                >
                  <template v-slot:item.no="{ item }">
                    {{ SelectUsersInApproveList.indexOf(item) + 1 }}
                  </template>
                  <template v-slot:item.firstName="{ item }">
                    {{ item.firstName }}
                  </template>
                  <template v-slot:item.lastName="{ item }">
                    {{ item.lastName }}
                  </template>
                  <template v-slot:item.email="{ item }">
                    {{ item.email }}
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-btn text @click="DeleteDataApproveDropdown(item)">
                      <img src="@/assets/close.png" width="15" height="15" />
                      <span style="color: #ff4839" class="ml-1 text-capitalize"
                        >Delete</span
                      >
                    </v-btn>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-card-actions class="section-dialog-actions">
          <div class="section-action-buttons">
            <v-btn
              color="success"
              class="rounded-lg px-6"
              v-if="EditStatus"
              :block="$vuetify.breakpoint.xsOnly"
              @click="UpdateDataSection()"
            >
              {{ $t("message.Update") }}
            </v-btn>
            <v-btn
              color="success"
              class="rounded-lg px-6"
              v-else
              :block="$vuetify.breakpoint.xsOnly"
              @click="AddDataSection()"
            >
              {{ $t("message.Create") }}
            </v-btn>
            <v-btn
              color="red"
              class="white--text rounded-lg px-6"
              variant="outlined"
              :block="$vuetify.breakpoint.xsOnly"
              @click="ClearDataSection()"
            >
              {{ $t("message.Cancel") }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "ManageSection",
  components: {},
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      items: [10, 15, 20, 50, 100],
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      search: "",
      no_run: 0,
      SectionDetailDialog: false,
      EditStatus: false,

      SectionID: null,
      SectionName: "",
      SectionNameENG: "",
      Active: null,

      UserID: null,
      Username: "",
      FirstName: "",
      LastName: "",

      SectionList: [],
      SelectUsersInApproveList: [],
      SelectUsersInApproveListTemp: [],
      UserApproveList: [],

      SelectUsersList: [],
      SelectUsersListTemp: [],
      UserNotApproveList: [],
      UsersList: [],

      SearchApprover: "",
      SearchUsers: "",
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("message.No"),
          sortable: false,
          align: "left",
        },
        {
          text: this.$t("message.Username"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.FirstName"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.LastName"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.Action"),
          align: "center",
          sortable: false,
        },
      ];
    },
    headersDropdown() {
      return [
        {
          text: this.$t("message.No"),
          align: "center",
          value: "no",
        },
        {
          text: this.$t("message.FirstName"),
          align: "left",
          value: "firstName",
          sortable: false,
        },
        {
          text: this.$t("message.LastName"),
          align: "center",
          value: "lastName",
          sortable: false,
        },
        {
          text: this.$t("message.Email"),
          align: "center",
          value: "email",
          sortable: false,
        },
        {
          text: this.$t("message.Action"),
          align: "center",
          value: "action",
          sortable: false,
        },
      ];
    },
    paginationTotalVisible() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 5;
      }

      if (this.$vuetify.breakpoint.smAndDown) {
        return 7;
      }

      return 10;
    },
  },

  async mounted() {
    let self = this;
    await self.getDataSectionList();
    await self.getDataUserApproveDropdownList();
    await self.getDataUsersDropdownList();
  },

  watch: {
    SearchApprover() {
      this.$refs.inputApprove.reset();
    },
    SearchUsers() {
      this.$refs.inputUser.reset();
    },
  },

  methods: {
    getDataSectionList() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: self.page,
        perPage: self.itemsPerPage,
      };
      axios
        .post(`${self.url}Management/getDataSectionList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.SectionList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        });
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: value,
        perPage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
      };
      axios
        .post(`${self.url}Management/getDataSectionList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.SectionList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: 1,
        perPage: value,
      };
      axios
        .post(`${self.url}Management/getDataSectionList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.SectionList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        });
    },

    SearchDataSectionList(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: value,
        page: 1,
        perPage: self.itemsPerPage,
      };
      axios
        .post(`${self.url}Management/getDataSectionList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.SectionList = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        });
    },

    OpenSectionDetailDialog(userID, type) {
      let self = this;
      if (type == "create") {
        self.UserID = null;
        self.FirstName = "";
        self.LastName = "";
        self.SelectUsersInApproveList = [];
        self.SelectUsersInApproveListTemp = [];
        self.SectionDetailDialog = true;
      } else {
        if (userID != null) {
          self.getDataSectionDetailBySectionID(userID);
        }
      }
    },

    getDataSectionDetailBySectionID(userID) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        id: userID,
      };
      axios
        .post(`${self.url}Management/getDataSectionDetailBySectionID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.BindingData(response.data.data);
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    getDataUserApproveDropdownList() {
      let self = this;
      axios
        .get(`${self.url}Management/getDataUserApproveDropdownList`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.UserApproveList = response.data.data;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        });
    },

    getDataUsersDropdownList() {
      let self = this;
      axios
        .get(`${self.url}Management/getDataUsersDropdownList`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.UsersList = response.data.data;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        });
    },

    AddDataDropdownApprove(value) {
      let self = this;
      if (value != null) {
        var CheckDuplicate = this.SelectUsersInApproveList.find(
          (x) => x.userID == value.userID
        );
        if (CheckDuplicate != null) {
          Swal.fire("Duplicate Data !");
        } else {
          var tempData = {
            userID: value.userID,
            firstName: value.firstName,
            lastName: value.lastName,
            email: value.email,
          };
          self.SelectUsersInApproveList.push(tempData);
          self.SelectUsersInApproveListTemp = self.SelectUsersInApproveList;
        }
      }
    },

    DeleteDataApproveDropdown(item) {
      let self = this;
      Swal.fire({
        text: "คุณต้องการลบใช่หรือไม่ !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Submit",
      }).then((result) => {
        if (result.isConfirmed) {
          var Index = self.SelectUsersInApproveList.indexOf(item);
          self.SelectUsersInApproveList.splice(Index, 1);
          Swal.fire("Success !");
        }
      });
    },

    BindingData(data) {
      let self = this;
      if (data != null) {
        self.UserID = data.userID;
        self.FirstName = data.firstName;
        self.LastName = data.lastName;
        self.SelectUsersInApproveList = data.approveList;
        self.SelectUsersInApproveListTemp = data.approveList;
        self.EditStatus = true;
        self.SectionDetailDialog = true;
      }
    },

    FillDataNameFromUserID(UserID){
      let self = this;
      if(UserID != null){
        let temp = self.UsersList.find(x => x.userID == UserID);
        if(temp != null){
          self.FirstName = temp.firstName;
          self.LastName = temp.lastName;
        } else {
          self.FirstName = "";
          self.LastName = "";
        }
      } else {
        self.FirstName = "";
        self.LastName = "";
      }
    },

    ClearDataSection() {
      let self = this;
      self.UserID = null;
      self.FirstName = "";
      self.LastName = "";
      self.SelectUsersInApproveList = [];
      self.SelectUsersInApproveListTemp = [];
      self.Active = false;
      self.EditStatus = false;
      self.SectionDetailDialog = false;
    },

    AddDataSection() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        userID: self.UserID, 
        approveList: self.SelectUsersInApproveList
      };
      axios
        .post(`${self.url}Management/AddDataSection`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
            self.getDataSectionList();
            self.ClearDataSection();
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    UpdateDataSection() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        userID: self.UserID,
        approveList: self.SelectUsersInApproveList
      };
      axios
        .post(`${self.url}Management/UpdateDataSection`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
            self.getDataSectionList();
            self.ClearDataSection();
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    InActiveSectionBySectionID(userID) {
      let self = this;
      let temp = {
        userID: userID,
      };
      Swal.fire({
        text: "คุณต้องการ In Active Section นี้ใช่หรือไม่ ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "green",
        cancelButtonColor: "#d33",
        confirmButtonText: "Submit",
      }).then((result) => {
        if (result.isConfirmed) {
          self.LoadingDialog = true;
          axios
            .post(`${self.url}Management/InActiveSectionBySectionID`, temp)
            .then(function (response) {
              if (response.data.status == 0) {
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.getDataSectionList();
              }
            })
            .catch(function (error) {
              Swal.fire({
                icon: "error",
                title: "Error...",
                width: 500,
                text: error.response.data.message,
              });
            })
            .finally(() => {
              self.LoadingDialog = false;
            });
        }
      });
    },

    GetColor(value) {
      if (value == true) {
        return "rgb(92, 184, 92,0.3)";
      } else {
        return "rgb(232, 34, 34,0.3)";
      }
    },

    GetColorText(value) {
      if (value == true) {
        return "rgb(92, 184, 92)";
      } else {
        return "rgb(232, 34, 34)";
      }
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },
  },
};
</script>
  <style scoped>
* >>> .v-data-table-header {
  background-color: black;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}

.table-responsive {
  width: 100%;
  overflow-x: auto;
}

.manage-section-page {
  margin-left: 10px;
  margin-right: 10px;
}

.section-filter-card,
.section-list-card {
  padding: 2%;
  margin-top: 2%;
  margin-bottom: 2%;
}

.section-filter-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.section-table-card {
  padding: 16px;
  margin-bottom: 16px;
}

.section-list-table {
  min-width: 680px;
  color: #332f2fde;
}

.section-pagination-col {
  display: flex;
  justify-content: center;
}

.section-page-size-col {
  display: flex;
  justify-content: flex-end;
}

.section-page-size {
  max-width: 180px;
}

.section-dialog-card {
  overflow: hidden;
}

.section-approve-table {
  min-width: 680px;
}

.section-dialog-actions {
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px;
}

.section-action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;
}

@media (max-width: 959px) {
  .section-list-table,
  .section-approve-table {
    min-width: 560px;
  }

  .section-page-size-col {
    justify-content: center;
  }

  .section-page-size {
    max-width: 220px;
  }
}

@media (max-width: 599px) {
  .manage-section-page {
    margin-left: 0;
    margin-right: 0;
  }

  .section-filter-card,
  .section-list-card {
    padding: 12px;
    margin-top: 12px;
    margin-bottom: 12px;
  }

  .section-filter-actions {
    display: block;
    padding-top: 0 !important;
  }

  .section-table-card {
    padding: 8px;
  }

  .section-list-table,
  .section-approve-table {
    min-width: 520px;
  }

  .section-dialog-card {
    border-radius: 0 !important;
  }

  .section-dialog-content {
    padding: 16px !important;
  }

  .section-dialog-actions {
    display: block;
    padding: 16px;
  }

  .section-action-buttons {
    display: block;
  }

  .section-action-buttons .v-btn {
    margin-top: 8px;
  }
}
</style>
  
